import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SopaLogo from "../assets/sopa.webp";
import axios from "axios";
import BASE_URL from "../Config";

const ExpressEntryPrint = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [registrationData, setRegistrationData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) {
      axios
        .post(`${BASE_URL}/getSingleSpotRegistration`, { id })
        .then((response) => {
          const apiData = response.data.data?.[0];
          if (!apiData) {
            setRegistrationData(null);
            return;
          }

          setRegistrationData({
            referenceNo: apiData.id,
            date: apiData.created_at.split("T")[0],
            delegateType: apiData.deletegate_category || "N/A",
            name: apiData.name,
            mobile: apiData.mobile,
            email: apiData.email,
            companyName: apiData.organization_name || "",
            gstNo: apiData.GSTIN || "",
            amount: `${apiData.total_amount}/-`,
            paymentMode: apiData.payment_mode || "N/A",
          });

          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching registration data", error);
          setLoading(false);
        });
    } else {
      console.log("No ID provided in the URL");
    }
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (!registrationData) return <div>No data available</div>;

  return (
    <>
      <div
        style={{
          backgroundColor: "#f5f5f5",
          padding: "30px",
          minHeight: "auto",
        }}
      >
        <div
          style={{
            maxWidth: "950px",
            margin: "0 auto 20px auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2
            style={{
              color: "black",
              fontWeight: 700,
              fontSize: "2rem",
              margin: 0,
            }}
          >
            EXPRESS ENTRY
          </h2>
          <div style={{ display: "flex", gap: "10px" }}>
            <button
              onClick={() => navigate("/review-list-of-spot-registration")}
              style={buttonStyle}
            >
              Go Back
            </button>
            <button
              onClick={() => {
                localStorage.clear();
                sessionStorage.clear();
                navigate("/admin/login");
              }}
              style={buttonStyle}
            >
              Logout
            </button>
          </div>
        </div>

        {/* Print Section */}
        <div
          id="print-section"
          style={{
            maxWidth: "1000px",
            margin: "0 auto",
            backgroundColor: "#ffffff",
            borderRadius: "5px",
            padding: "20px",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        >
          {[1, 2].map((copy) => (
            <div
              key={copy}
              className="printable-page"
              style={{
                backgroundColor: "#eaf9fe",
                padding: "24px 30px",
                borderRadius: "4px",
                marginTop: "20px",
                marginBottom: "40px",
                pageBreakInside: "avoid",
                breakInside: "avoid",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "15px",
                }}
              >
                <img
                  src={SopaLogo}
                  alt="SOPA"
                  className="sopa-logo"
                  style={{ height: "70px" }}
                />
              </div>

              <div
                className="header-info"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  border: "1px solid black",
                  padding: "10px 14px",
                  backgroundColor: "#eaf9fe",
                  fontWeight: 500,
                  fontSize: "16px",
                  marginBottom: "20px",
                }}
              >
                <span>
                  Reff. No.<strong> #{registrationData.referenceNo}</strong>
                </span>
                <span>
                  Date <strong>{registrationData.date}</strong>
                </span>
              </div>

              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  {renderRow("Deletagate Type", registrationData.delegateType)}
                  {renderRow("Name", registrationData.name)}
                  {renderRow("Mobile", registrationData.mobile)}
                  {renderRow("Email", registrationData.email)}
                  {renderRow("Company Name", registrationData.companyName)}
                  {renderRow("GST No.", registrationData.gstNo)}
                  {renderRow("Amount", registrationData.amount)}
                  {renderRow("Payment Mode", registrationData.paymentMode)}
                </tbody>
              </table>
            </div>
          ))}

          <div style={{ textAlign: "right", marginTop: "20px" }}>
            <button
              className="print-button"
              onClick={() => window.print()}
              style={{
                padding: "8px 20px",
                backgroundColor: "#f7cf1c",
                color: "black",
                fontWeight: "bold",
                border: "none",
                borderRadius: "20px",
                cursor: "pointer",
              }}
            >
              PRINT
            </button>
          </div>
        </div>
      </div>

      {/* Print styles */}
      <style>
        {`
       @media print {
   body * {
    visibility: hidden;
  }

  #print-section, #print-section * {
    visibility: visible;
  }

  #print-section {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 20px 30px;
    box-sizing: border-box;
  }

  .printable-page {
    page-break-before: avoid !important;
    page-break-inside: avoid !important;
    page-break-after: avoid !important;

    break-before: avoid !important;
    break-inside: avoid !important;
    break-after: avoid !important;

    display: block;
    overflow: hidden;
    margin-bottom: 40px !important;
    padding: 24px 30px !important;
  }

  .print-button {
    display: none;
  }

  @page {
    size: A4;
    margin: 1rem;
  }

  html, body {
    margin: 0;
    padding: 0;
    font-size: 16px;
  }

  table, tr, td {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    font-size: 16px !important;
    padding: 9px 18px !important;
  }

  .sopa-logo {
    min-height: 70px !important;
  }

  .header-info {
    font-size: 16px !important;
    padding: 14px 16px !important;
  }
}
   `}
      </style>
    </>
  );
};

const renderRow = (label, value) => (
  <tr>
    <td style={tdStyle}>{label}</td>
    <td style={tdStyle}>{value}</td>
  </tr>
);

const tdStyle = {
  border: "1px solid black",
  padding: "12px 14px",
  fontSize: "16px",
};

const buttonStyle = {
  backgroundColor: "#4696A0",
  color: "white",
  border: "none",
  borderRadius: "20px",
  padding: "8px 20px",
  fontWeight: 600,
  cursor: "pointer",
};

export default ExpressEntryPrint;
